import React from "react";
import {Loader} from "../../components/Loader";
import {Dictionary} from "../../components/Dictionary";
import {RightAside} from "../../components/Aside/RightAside";
import {SysButton} from "../../components/Elements/SysButton";
import {StatusPage} from "../StatusPage";
import {Util} from "../../components/Util";
import {DateTime} from "../../components/ListComponent/DateTime";
import {DetailsWithList} from "../../components/DetailsWithList";
import {OrderScheduleEdit} from "./OrderScheduleEdit";
import {OrderScheduleData} from "./OrderScheduleData";

export class OrderScheduleDetails extends DetailsWithList {
    protected dictionary: Dictionary = new Dictionary();

    componentDidMount() {
        if (this.user.hasRight('order-schedule/details') === false && this.user.hasRight('order-schedule/edit') === false) {
            return;
        }
        this.fetchUrl = '/order-schedule/' + window.location.pathname.split('/').pop();
        this.fetchItem();
    }

    render() {
        if (this.user.hasRight('order-schedule/details') === false && this.user.hasRight('order-schedule/edit') === false) {
            return <StatusPage code={403} message="forbidden"/>;
        }
        if (this.state?.code && this.state?.message) {
            return <StatusPage code={this.state.code} message={this.state.message}/>;
        }
        if (typeof this.state?.item === 'undefined') {
            return <Loader/>;
        }
        return (
            <div className="x-form">

                <input type="hidden" name="id" defaultValue={this.state?.item.id || ''}/>

                <div className="row gx-4">
                    <div className="col-md-12 col-lg-6 details">
                        <h6>
                            {this.dictionary.get['order-schedule-details']}
                            {this.user.hasRight('order-schedule/edit') &&
                                <SysButton onClick={RightAside.open} type={'PencilFill'} data-open={'#edit-details'}
                                           text={this.dictionary.get['edit']}/>}
                        </h6>

                        <div className="table-responsive">
                            <OrderScheduleData item={this.state.item}/>
                        </div>
                        {this.user.hasRight('order-schedule/edit') && <OrderScheduleEdit item={this.state.item} services={this.state.services}/>}
                    </div>


                    <div className="col-md-12 col-lg-6 details">
                        <h6>
                            {this.dictionary.get['other-info']}
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                <tbody>
                                <tr>
                                    <td>{this.dictionary.get['created_at']}</td>
                                    <td>{DateTime.create({value: this.state.item.created_at, inline: true})}</td>
                                </tr>
                                <tr>
                                    <td>{this.dictionary.get['created_by']}</td>
                                    <td>{this.state.item.created_by}</td>
                                </tr>
                                <tr>
                                    <td>{this.dictionary.get['updated_at']}</td>
                                    <td>{DateTime.create({value: this.state.item.updated_at, inline: true})}</td>
                                </tr>
                                <tr>
                                    <td>{this.dictionary.get['updated_by']}</td>
                                    <td>{this.state.item.updated_by}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <h6>
                            {this.dictionary.get['items']} &nbsp;
                            <small>{this.state.item.items.length ? this.state.item.items.length : '-'} {this.dictionary.get['pc']}</small>
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                <thead>
                                <tr>
                                    <th>{this.dictionary.get['product_id']}</th>
                                    <th>{this.dictionary.get['sku']}</th>
                                    <th>{this.dictionary.get['name']}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.item.items.map(function (elem: any) {
                                    return (
                                        <tr key={elem.sku}>
                                            <td>{elem.id ? Util.link(elem.id, '/product/details/' + elem.id) : '-'}</td>
                                            {Util.copyCellWithIcon(elem.sku || '', {style: {color: '#3366FF'}})}
                                            <td>{elem.name || '-'}</td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
